import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';

function getContent(payment) {
    return payment.performedBy === 'SELLER'
        ? 'Du har hevet kjøpet'
        : 'Kjøpet er hevet';
}

const PaymentRevertedSummary = ({ payment }) => (
    <StatusSummaryButton
        href="/handel-kansellert"
        statusSummary="Handelen er kansellert."
    >
        {getContent(payment)}
    </StatusSummaryButton>
);

PaymentRevertedSummary.propTypes = {
    payment: paymentDataPropTypes.isRequired,
};

export default PaymentRevertedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/summaries/paymentRevertedSummary.jsx